import { Component, Prop, h, Event, EventEmitter, State } from '@stencil/core';

import { PageAnswer, Questions } from '../../model/index'
@Component({
  tag: 'sg-question',
  shadow: false
})
export class Question {
  @Prop() name?: string;
  @Prop() user?: string;
  @Prop() email?: string;
  @Prop() textsMap: Map<string, any>;

  @Prop() questions: Questions;
  @Prop() buttonselect: string;
  @Prop() buttonback: string;
  @Prop() buttonreset: string;
  @Prop() prevquestion: number;
  @Prop() disabledAnswers: Array<string> = [];
  @State() answerSelected: number;

  @Event({
    eventName: "nextQuestion",
    bubbles: false,
  }) nextQuestion: EventEmitter<PageAnswer>;

  @Event({
    eventName: "backQuestion",
    bubbles: false,
  }) backQuestion: EventEmitter<number>;

  @Event({
    eventName: "resetQuestion",
    bubbles: false,
  }) resetQuestion: EventEmitter;

  @Event({
    eventName: "sendToSummary",
    bubbles: false,
  }) sendToSummary: EventEmitter;


  clickChooseAnswer(answerOrd: number) {
    this.answerSelected = answerOrd;
  }

  clickSelect(questionId: number) {
    if (this.answerSelected) {
      const idans = this.answerSelected;
      this.answerSelected = undefined;
      this.nextQuestion.emit({ answerOrder: idans, questionOrder: questionId });
    }
  }

  disableOptions() {
    var fullDisabled = true;
    this.questions.answers.map((answer) => {
      answer.active = true;
      if (this.disabledAnswers.includes("" + answer.orderanswer)) {
        answer.active = false;
        //console.log("deshabilitada: " + answer.orderanswer)
      } else {
        //console.log("respuesta: " + answer.orderanswer + " stock: " + answer.withStock);
        answer.active = answer.withStock;
      }
      if(answer.active){
        fullDisabled = false;
      }
    })
    if(fullDisabled){
      this.sendToSummary.emit();
    }
  }

  clickBack(id: number) {
    this.backQuestion.emit(id);
  }

  clickReset() {
    this.answerSelected = undefined;
    this.resetQuestion.emit();
  }

  render() {
    this.disableOptions();
    if (this.questions) {

      return (
        <div class="html">
          <div class="body">
            <div id={'question_' + this.questions.orderquestion} class="Collapsible js-Collapsible">
              <header class="section-header u-padTop2">
                <h1 class="u-textCenter" >{this.name ? this.name + ',' : ''} {this.textsMap.get(this.questions.title)}</h1>
              </header>
              <div class={this.questions.answersImages ? 'sg-options card_image' : 'sg-options only_text'}>
                {
                  this.questions.answers.map((answer) => {
                    if (answer.active) {
                      return (
                        <div class={this.questions.answersImages ? 'sg-card' : 'sg-card no-image'}>
                          <label class="" >
                            <input type="radio" class={this.answerSelected == answer.orderanswer ? 'answer-checked' : ''} name={`question_${this.questions.orderquestion}`} onClick={() => this.clickChooseAnswer(answer.orderanswer)}
                              id={`id_${this.questions.orderquestion}_${answer.orderanswer}`}></input>
                            <img src={answer.image} alt={this.textsMap.get(answer.title)} class="sg-card-image"></img>
                            <p class="sg-title">{this.textsMap.get(answer.title)}</p>
                          </label>
                        </div>
                      );
                    }
                  }
                  )}
              </div>
            </div>
          </div>
          <div class="u-pad3 buttons-steps">

            {this.questions.orderquestion > 1 ? (
              <button id="btnReset" class="btn btn--small btn-back" title={this.textsMap.get(this.buttonreset)} onClick={() => this.clickReset()}>
                <svg fill="#000000" height="64px" width="64px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 383.748 383.748">
                  <g id="SVGRepo_bgCarrier" stroke-width="0" />
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />
                  <g id="SVGRepo_iconCarrier"> <g> <path d="M62.772,95.042C90.904,54.899,137.496,30,187.343,30c83.743,0,151.874,68.13,151.874,151.874h30 C369.217,81.588,287.629,0,187.343,0c-35.038,0-69.061,9.989-98.391,28.888C70.368,40.862,54.245,56.032,41.221,73.593 L2.081,34.641v113.365h113.91L62.772,95.042z" /> <path d="M381.667,235.742h-113.91l53.219,52.965c-28.132,40.142-74.724,65.042-124.571,65.042 c-83.744,0-151.874-68.13-151.874-151.874h-30c0,100.286,81.588,181.874,181.874,181.874c35.038,0,69.062-9.989,98.391-28.888 c18.584-11.975,34.707-27.145,47.731-44.706l39.139,38.952V235.742z" /> </g> </g>
                </svg>
              </button>
            ) : null}
            <button id="btnNext" class={!this.answerSelected ? 'btn btn--small btn-next button-disabled' : 'btn btn--small btn-next'} disabled={!this.answerSelected} value={this.buttonselect} onClick={() => this.clickSelect(this.questions.orderquestion)}>
              {this.textsMap.get(this.buttonselect)}
            </button>

          </div>
        </div>
      );

    } else {
      return (<sg-pagenot></sg-pagenot>);
    }
  }
}
